import ConfigContext from './ConfigContext'

const ConfigConsumer = ConfigContext.Consumer ;

export default ConfigConsumer ;